import React from "react";
import "./HowItWorks.css";

const HowItWorks = () => {
  return (
    <div className="hiw-container_v1_kf">
      <div className="hiw-content-wrapper-kf">
        <img
          src="/assets/img/Group 429.png"
          alt="How it Works"
          className="hiw-kf"
        />
      </div>
    </div>
  );
};

export default HowItWorks;
